module.exports = __webpack_public_path__ + "static/media/money-bill-wave-alt.aac445d3.svg";